"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWithImageChoicesGameplayComponentPropsFactory = void 0;
const asset_key_generator_1 = require("../../asset_key_generator");
const types_1 = require("../../gameplay/types");
const GameplayComponentPropsFactory_1 = require("./GameplayComponentPropsFactory");
const shuffle_array_1 = __importDefault(require("shuffle-array"));
class TextWithImageChoicesGameplayComponentPropsFactory extends GameplayComponentPropsFactory_1.GameplayComponentPropsFactory {
    createQuestionTextProps() {
        if (this.card.cardQuestion.questionText) {
            const props = {
                text: `${this.card.cardQuestion.questionText}`,
                className: 'questionText-text',
                gameplayStyle: this.style,
            };
            return props;
        }
        return undefined;
    }
    createQuestionChoiceProps() {
        // choice will come from CardTemplate.cardQuestion.imageChoices
        // randomly select requested choice count, popquiz will need 4 fixed, popstudy depends on choice count
        // must include the answer choice
        if (this.card.cardQuestion.imageChoices.length === 0) {
            return undefined;
        }
        let answerChoices = [];
        if (this.style === types_1.GameplayStyle.PopQuiz) {
            answerChoices = this.card.cardQuestion.imageChoices;
        }
        else {
            answerChoices = (0, shuffle_array_1.default)(this.card.cardAnswer.answerTexts.concat(shuffle_array_1.default.pick(this.card.cardQuestion.imageChoices.filter(img => {
                return !this.card.cardAnswer.answerTexts.includes(img);
            }), {
                picks: this.card.gameplayInfo.choiceCount -
                    this.card.cardAnswer.answerTexts.length,
            })));
        }
        const imageURLS = new Set();
        if (answerChoices.length > 0) {
            answerChoices.map(image => {
                var _a;
                const assetKey = asset_key_generator_1.AssetKeyGenerator.key(image, asset_key_generator_1.AssetType.Image);
                const url = (_a = this.fileUrls.get(assetKey)) !== null && _a !== void 0 ? _a : '';
                imageURLS.add(url);
            });
        }
        const props = {
            choices: Array.from(imageURLS),
            imageNames: answerChoices,
            highlightedChoices: [],
            disabled: false,
            className: 'questionChoice-image',
            gameplayStyle: this.style,
        };
        return props;
    }
    createCorrectAnswerProps() {
        // TBD
        return undefined;
    }
    createIncorrectAnswerProps() {
        // TBD
        return undefined;
    }
}
exports.TextWithImageChoicesGameplayComponentPropsFactory = TextWithImageChoicesGameplayComponentPropsFactory;
